import { PdsWidget } from './pds-widget';
/**
 * This polymer component is used to provide a container for a sequence of text
 * that can be read by voice over or any screen reader.
 * This is called by the tool-kit by invoking the announceText() function and passing it as String.
 * The text is placed between p tags.
 */

export class PdsAnnounce extends PdsWidget {
  is: 'pds-announce-text';
  scopeClass: string; //scopeClass should be used in other polymer components that use pds-announce-text to make sure the correct class is applied
  id = 'default'; //Allows this to observe id upon registering the container
  properties = {
    id: {
      type: String
    }
  };

  /**
   * Initially the id attribute is default .. so I want to register as a default container
   */

  ready(): void {
    super.ready();
    this.pds.accessibility.registerAnnounceTextComponent(this);
  }

  /**
   * if attribute changes, I delete the latest entry added to default.. and add register a new
   * container with the new id
   */

  attributeChanged(name: string, type: any): void {
    if (name === 'id') {
      this.pds.accessibility.removeAnnounceTextComponentFromDefault();
      this.pds.accessibility.registerAnnounceTextComponent(this, this.id);
    }
  }

  detached(): void {
    super.detached();
    if (this.id) {
      this.pds.accessibility.unregisterAnnounceTextComponent(this.id);
    } else {
      this.pds.accessibility.unregisterAnnounceTextComponent();
    }
  }

  announceText(text: string): void {
    let element = this.querySelector('.pds-announce-text-content');
    if (element != null) {
      let paragraph = document.createElement('p');
      paragraph.textContent = text;
      let node = (<any>element).appendChild(paragraph);
      setTimeout(function (): void {
        node.remove();
      }, 60000);
    }
  }

  messageKeysUpdated(): void {

  }
}
